define('glu/grid/filter/singularFilterProcessor',['require','./filterProcessor'],function(require) {
    'use strict';

    var FilterProcessor = require('./filterProcessor');

    return FilterProcessor.extend({
        addFilter: function(filter) {
            this.filters.reset([filter]);
            this.process();
        }
    });
});

